
/*
 * Общие функции-помогаторы
 *
 * */

; window.CK = (() => {
	"use strict";

	if (!window.Result) {
		console.error('[CK] Result.js не загружен до CompKit.js');
	}
	if (!window.HttpClient) {
		console.error('[CK] HttpClient.js не загружен до CompKit.js');
	}
	if (!window.MoK) {
		console.error('[CK] ModalsKit.js не загружен до CompKit.js');
	}
	if (!window.aAlert) {
		console.error('[CK] aAlert не загружен до CompKit.js');
	}
	if (!window.aConfirm) {
		console.error('[CK] aConfirm не загружен до CompKit.js');
	}

	const STATUS = {
		CHERNOVIK: 1, NA_UTVERZHD: 2, OBYAVL: 3, PRIEM_ZAYAVOK: 4, PRIEM_ZAYAVOK_END: 5,
		UCHASTNIKI_OPRED: 6, PROVEDENIE: 7, PODVEDENIE_ITOGOV: 8, ZAVERSH: 9, OTMEN: 10, PRIOST: 12
	};
	const FORM = { OF: 1, ZF: 2, PP: 4, KT: 5, AU: 6, AK: 8, AG: 9 };
	const SUBTYPE = { openAuction: 1, none: 0 };



	const compApi = {
		/**
		 * GET запрос на получение данных торгов
		 *
		 * @param {string|number|null} competitionId
		 * @param {{disableLoad?: boolean}} [options]
		 * @returns {Promise<Result>} — всегда Result, reject не бывает
		 */
		async getCompData(competitionId = null, options = {}) {
			const { disableLoad = false } = options;

			if (disableLoad) {
				return Result.fail("Отключена загрузка данных с сервера");
			}

			if (!competitionId) {
				return Result.fail("Не указан идентификатор торгов");
			}

			const result = await HttpClient.get(`/ajax/api/comp_data?id=${competitionId}`);

			if (!result.isSuccess()) {
				return result;
			}

			if (!result.hasData) {
				return Result.fail(result.message || "Нет данных или ошибка в ответе сервера", { code: result.code });
			}

			// Блок с данными
			const item = result.item;

			return result.with({
				data: item?.data || {},
				context: item?.context || {},
			});
		},

		/**
		 * API запрос на удаление черновика торгов
		 * POST /ajax/api/comp_delete
		 *
		 * @param {string|number} competitionId - ID торгов (competition_id)
		 * @returns {Promise<{success: boolean, error?: string, data?: Array, message?: string}>}
		 */
		async compDelete(competitionId) {
			if (!competitionId) {
				return { success: false, error: "Не указан ID торгов!" };
			}

			try {
				const response = await fetch('/ajax/api/comp_delete', {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-Requested-With': 'XMLHttpRequest'
					},
					body: JSON.stringify({ competition_id: competitionId })
				});

				// бэк всегда возвращает JSON с полями success, message, data
				const result = await response.json();

				if (!result.success) {
					// Обработка ошибок от бэкенда (SCHEMA_INVALID, ACCESS_DENIED, COMPETITION_NOT_FOUND и т.д.)
					return { success: false, error: result.message || "Ошибка удаления черновика" };
				}

				return { success: true, data: result.data, message: result.message };

			} catch (e) {
				console.error('[compUtils.compDelete] Ошибка удаления черновика:', e);
				return { success: false, error: e.message || "Ошибка сети" };
			}
		},

		/**
		 * API запрос на проверку торгов перед публикацией
		 * POST /ajax/api/comp_check
		 *
		 * @param {string|number} competitionId - ID торгов (competition_id)
		 * @returns {Promise<{success: boolean, error?: string, errors?: Array, data?: Array}>}
		 */
		async checkCompetition(competitionId) {
			if (!competitionId) {
				return { success: false, error: "Не указан ID торгов!" };
			}
			try {
				const response = await fetch(`/ajax/api/comp_check?id=${competitionId}`, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						'X-Requested-With': 'XMLHttpRequest'
					},
					body: JSON.stringify({ id: competitionId })
				});

				const result = await response.json();
				const backendData = result.data?.[0];
				const warnings = backendData?.warnings || null;
				const errors = backendData?.errors || null;

				if (!result || result.code !== 200 || !result.success) {
					return {
						success: false,
						error: result.message || "Ошибка проверки торгов",
						errors: errors,
						warnings: warnings,
					};
				}

				return {
					success: true,
					data: backendData,
					warnings: warnings,
					errors: errors
				};
			} catch (e) {
				console.error('[CK.checkCompetition] Ошибка проверки торгов:', e);
				return { success: false, error: e.message || "Ошибка сети" };
			}
		},
	};

	const compActions = {
		/**
		 * Внутренний метод: получает ВСЕ возможные значимые действия для торгов
		 */
		_getPossibleActions(compData) {
			if (!compData) {
				return [];
			}

			const statusId = parseInt(compData.status_id, 10);
			const formId = parseInt(compData.form_id, 10);
			const typeId = parseInt(compData.type_id, 10);
			const subtypeId = parseInt(compData.subtype_id, 10);
			const compId = compData.id;
			const compUrl = '/' + (compData?.url || '');

			if (!compId || isNaN(statusId) || isNaN(formId)) {
				return [];
			}

			const actions = [];

			if (statusId === STATUS.PRIEM_ZAYAVOK_END && (formId === FORM.OF || formId === FORM.ZF || formId === FORM.KT)) {
				actions.push({ key: 'GET_PROTO_DOPUSK', name: 'Получить протокол определения участников торгов', url: `protokolDopuska?id=${compId}`, priority: 5 });
			}

			if (statusId === STATUS.PODVEDENIE_ITOGOV && formId !== FORM.PP && !(formId === FORM.AU && subtypeId !== SUBTYPE.openAuction)) {
				actions.push({ key: 'GET_PROTO_RESULT', name: 'Получить протокол о результатах проведения торгов', url: `protokolResult?id=${compId}`, priority: 4 });
			}

                        if (compData.pp_ended_without_bids === true || compData.pp_ended_without_bids === 'true') {
                                actions.push({ key: 'GET_PROTO_RESULT_NO_ZAYAV', name: 'Сформировать протоколы о результатах торгов по лотам без заявок', url: `protokolResultPPall?id=${compId}`, priority: 5 });
                        }

			// ===== ДЕЙСТВИЯ ДЛЯ ЛОТОВ
			// требуют заключения дкп
			if (compData.dkp_sign_confirm === true || compData.dkp_sign_confirm === 'true') {
				actions.push({ key: 'TRANSFER_DKP_SIGN_INFO', name: 'Передать сведения о заключении договора купли-продажи', url: compUrl + `#addDKP`, priority: 7 });
			}

			// предложения своей цены
			if (compData.has_offer === true || compData.has_offer === 'true') {
				actions.push({ key: 'HAS_OFFERS', name: 'Рассмотреть предложение о покупке', url: compUrl + "#offers", priority: 6 });
			}

			// рассмотрения заявок на периоде если есть не отозванные заявки
			//			if (compData.has_period_zayavs === true || compData.has_period_zayavs === 'true') {
			//				actions.push({key: 'HAS_PERIOD_ZAYAVS', name: 'Просмотр заявок по торгам', url: `showPartiCipation?comp_id=${compId}`, priority: 6});
			//			}

			if (compData.has_zadat_request === true || compData.has_zadat_request === 'true') {
				actions.push({ key: 'HAS_ZADAT_REQUEST', name: 'Заявление на перечисление задатка', url: ``, priority: 6 });
			}

			// Перевести (вернуть) задаток


			// Сформировать протокол допуска торгов по лоту за период
			if (compData.need_proto_dopusk === true || compData.need_proto_dopusk === 'true') {
				actions.push({ key: 'NEED_PROTO_DOPUSK', name: 'Сформировать протокол допуска торгов по лоту за период', url: compUrl + `#showPublicDopuskPeriod`, priority: 6 });
			}


			return actions;
		},

		/**
		 * Получение ОДНОГО значимого действия для торгов
		 * @param {object} compData - данные о торгах
		 * @param {string} compUrl - URL торгов
		 * @returns {object|null}
		 */
		getRequiredAction(compData) {
			const actions = this._getPossibleActions(compData);

			if (actions.length === 0) {
				return null;
			}

			// Сортируем по убыванию приоритета и возвращаем самое важное
			actions.sort((a, b) => b.priority - a.priority);
			return actions[0];
		},

		/**
		 * Собирает все доступные действия для торгов
		 */
		getAllActions(compData) {
			if (!compData) {
				return [];
			}

			const statusId = parseInt(compData.status_id, 10);
			const compId = compData.id;
			const compUrl = '/' + (compData?.url || '');
			const actions = [];
			const is_org_archive = (compData?.is_org_archive || false);

			// Для черновика (в работе)
			if (statusId === 1) {
				actions.push({
					key: 'DELETE_DRAFT',
					name: 'Удалить черновик',
					url: `deleteCompetition?id=${compId}`,
					priority: 100,
					danger: true
				});

				actions.push({ key: 'SIGN_AND_PUBLISH', name: 'Подписать и опубликовать торги', url: `publishCompetitions?id=${compId}`, priority: 1 });
			}

			if ((statusId === 1 || statusId === 9 || statusId === 10) && !is_org_archive) {
				actions.push({
					key: 'TO_ARCHIVE',
					name: 'Переместить в архив',
					url: '',
					priority: -1,
					danger: false,
					onclick: `CabinetSeller.competitionToArchive(${compId}, this); return false;`
				});
			}

			// все значимые действия
			const possibleActions = this._getPossibleActions(compData, compUrl);
			possibleActions.forEach(action => {
				actions.push({
					key: action.key,
					name: action.name,
					url: action.url,
					priority: (action.priority || 0) + 50,
					danger: action.danger || false
				});
			});

			// для всех
			actions.push({
				key: 'OPEN',
				name: 'Открыть торги',
				url: compUrl,
				priority: 0
			});

			// Сортируем по убыванию приоритета
			actions.sort((a, b) => b.priority - a.priority);
			return actions;
		},

	};

	const UI = {
		// API запрос с модалками и действиями
		async compDelete(compId = null) {
			if (!compId) {
				await aAlert("Не удалось определить ID торгов");
				return false;
			}

			const isConfirmed = await aConfirm("Удалить черновик?");
			if (!isConfirmed) {
				return false;
			}

			try {
				const result = await MoK.load.withLoading(
					() => compApi.compDelete(compId),
					{ text: "Удаление черновика…", delay: 200 }
				);

				if (result.success) {
					await aAlert("Черновик удален");
					// Перезагружаем страницу после успешного удаления
					// можно потом динамически сделать
					window.location.reload();
				} else {
					await aAlert(result.error || "Ошибка удаления черновика");
				}
			} catch (error) {
				console.error('[confirmDeleteDraft] Ошибка:', error);
				await aAlert("Ошибка сети при удалении");
			}
		}

	}

	// /**
	//  * Низкоуровневый POST для priceGraph
	//  *
	//  * @param {string} action - list | calc | reset | add | mod | del | deleteOutside | setLastDate
	//  * @param {object} payload - остальные поля запроса (обязательно lot_id)
	//  */
	// async function post(action, payload = {}) {
	//         if (!payload.lot_id) {
	//                 return { success: false, error: "Не указан ID лота!" };
	//         }

	//         try {
	//                 const response = await fetch("/ajax/api/price_edit", {
	//                         method: "POST",
	//                         headers: {
	//                                 "Content-Type": "application/json",
	//                                 "X-Requested-With": "XMLHttpRequest",
	//                         },
	//                         body: JSON.stringify({ action, ...payload }),
	//                 });

	//                 // бэк всегда возвращает JSON с полями success, message, data
	//                 const result = await response.json();

	//                 if (!result.success) {
	//                         return { success: false, error: result.message || "Ошибка операции с графиком" };
	//                 }

	//                 return { success: true, data: result.data || {}, message: result.message };
	//         } catch (e) {
	//                 return { success: false, error: e.message || "Ошибка сети" };
	//         }
	// }

	// const priceGraphApi = {
	//         /** Получить текущий график лота */
	//         getSchedule(lotId) {
	//                 return post("list", { lot_id: lotId });
	//         },

	//         /** Рассчитать график по шаблону авторасчёта */
	//         calc(lotId, tpl) {
	//                 return post("calc", { lot_id: lotId, ...tpl });
	//         },

	//         /** Очистить график */
	//         reset(lotId) {
	//                 return post("reset", { lot_id: lotId });
	//         },

	//         /** Добавить интервал (row — поля одной строки) */
	//         addRow(lotId, row) {
	//                 return post("add", { lot_id: lotId, ...row });
	//         },

	//         /** Изменить интервал (row.id обязателен) */
	//         modRow(lotId, row) {
	//                 return post("mod", { lot_id: lotId, ...row });
	//         },

	//         /** Удалить интервал по id */
	//         delRow(lotId, rowId) {
	//                 return post("del", { lot_id: lotId, id: rowId });
	//         },

	//         /** Удалить периоды, выходящие за дату окончания приёма заявок */
	//         deleteOutside(lotId) {
	//                 return post("deleteOutside", { lot_id: lotId });
	//         },

	//         /** Сдвинуть дату окончания приёма заявок к концу последнего периода */
	//         setLastDate(lotId) {
	//                 return post("setLastDate", { lot_id: lotId });
	//         },
	// }

	// то, что будет доступно снаружи
	const publicAPI = {
		...compApi,
		...compActions,
		UI: UI,
		// price: priceGraphApi,
	};

	return publicAPI;
})();
